"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import AutoStartConfig from "@/app_views/settings/settingconfig/AutoStartConfig.vue";
import API from "@ym-framework/api-utils";
import FileSaveConfig from "@/app_views/settings/settingconfig/FileSaveConfig.vue";
import ServiceConfig from "@/app_views/settings/settingconfig/ServiceConfig.vue";
import VersionConfig from "@/app_views/settings/settingconfig/VersionConfig.vue";
import DeviceConfig from "@/app_views/settings/settingconfig/DeviceConfig.vue";
import { AccountSessionMixins } from "@/service/account-session";
import ChangeColorConfig from "@/app_views/settings/settingconfig/ChangeColorConfig.vue";
import LanguageConfig from "@/app_views/settings/settingconfig/LanguageConfig.vue";
import AutoOpenLoginConfig from "@/app_views/settings/settingconfig/AutoOpenLoginConfig.vue";
import FlowSavingConfig from "@/app_views/settings/settingconfig/FlowSavingConfig.vue";
import OpenIconConfig from "@/app_views/settings/settingconfig/OpenIconConfig.vue";
import ReopenPageConfig from "@/app_views/settings/settingconfig/ReopenPageConfig.vue";
import BrowserVersionConfig from "@/app_views/settings/settingconfig/BrowserVersionConfig.vue";
let Setting = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.version = "";
    this.count = 0;
    this.timer = null;
    this.platform = null;
    this.devVersion = null;
  }
  mounted() {
    return __async(this, null, function* () {
      let response = yield API.get(`api://base.local/update/version`);
      this.version = response.data.version;
      this.platform = response.data.os;
    });
  }
  toScreen(position) {
    switch (position) {
      case position:
        document.querySelector(`#${position}`).scrollIntoView({
          behavior: "smooth"
        });
        break;
    }
  }
  toExtensions() {
    window.open("https://extension.kuajingvs.com/", "_blank");
  }
};
Setting = __decorateClass([
  Component({
    components: {
      DeviceConfig,
      AutoOpenLoginConfig,
      VersionConfig,
      ServiceConfig,
      FileSaveConfig,
      AutoStartConfig,
      LanguageConfig,
      ChangeColorConfig,
      FlowSavingConfig,
      OpenIconConfig,
      ReopenPageConfig,
      BrowserVersionConfig
    }
  })
], Setting);
export {
  Setting as default
};
